"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
/**
 * Checkbox custom component use for react-select.
 * @param props receive from react-select.
 * https://react-select.com/components#components
 * @return {JSX}
 */
var CheckboxCustom = function CheckboxCustom(props) {
  var _props$selectProps$co = props.selectProps.components,
    _onChange = _props$selectProps$co.onChange,
    statusChecked = _props$selectProps$co.statusChecked;
  var data = props.data;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-custom-component-oss"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "child-indent"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: data.value,
    checked: statusChecked.includes(data.value),
    type: "checkbox",
    onChange: function onChange(e) {
      return _onChange(e.target.checked, data);
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ControlLabel, {
    htmlFor: data.value
  }, data.label)));
};
CheckboxCustom.propTypes = {
  data: _propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  }).isRequired,
  selectProps: _propTypes.default.shape({
    components: _propTypes.default.shape({
      onChange: _propTypes.default.func,
      statusChecked: _propTypes.default.shape([])
    })
  }).isRequired
};
var _default = CheckboxCustom;
exports.default = _default;